import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  // 🔹 Close on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isMenuOpen, closeMenu]);

  // 🔥 Close on scroll
  useEffect(() => {
    if (!isMenuOpen) return;

    const handleScroll = () => closeMenu();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMenuOpen, closeMenu]);

  const scrollToSection = useCallback((id) => {
    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      closeMenu();
    } else {
      navigate("/", { replace: false });

      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [navigate, closeMenu]);

  return (
    <header>
      <div className="navbar fixed-top">

        <Link to="/" className="logo-container" onClick={() => scrollToSection("hero")}>
          <img src={logo} alt="Fryum Tech Logo" className="logo" />

          <div className="logo-text">
            <h1>FryumTech Solutions</h1>
            <p>"Your Growth, Our Success"</p>
          </div>
        </Link>

        <button
          className="hamburger"
          ref={hamburgerRef}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          ☰
        </button>

        <nav
          id="nav-menu"
          ref={menuRef}
          className={isMenuOpen ? 'open' : ''}
        >
          {[
            ["hero", "Home"],
            ["services", "Services"],
            ["engineering", "Technology"],
            ["about", "About"],
            ["team", "Team"],
            ["project", "Project"],
            ["contact", "Contact Us"],
          ].map(([id, label]) => (
            <a
              key={id}
              className="nav-item"
              onClick={() => scrollToSection(id)}
            >
              {label}
            </a>
          ))}
        </nav>

      </div>
    </header>
  );
};

export default Navbar;
